import React from 'react';
import { FormattedMessage } from 'react-intl';

export const Errors = {
    DEFAULT: (
        <FormattedMessage
            id='errors.default'
            description='Default error message'
            defaultMessage='An error occurred'
        />
    ),
    SHIPMENT_LABEL_ALREADY_ADDED: (
        <FormattedMessage
            id='errors.shipmentLabelAlreadyAdded'
            description='Shipment label already added error message'
            defaultMessage='Shipment label was already added, remove it before trying to scan another label.'
        />
    ),
    FAILED_TO_LOAD: (
        <FormattedMessage
            id='errors.failedToLoad'
            description='Failed to load error message'
            defaultMessage='Failed to load the requested data'
        />
    ),
    LABEL_ALREADY_IN_USE: (
        <FormattedMessage
            id='errors.labelAlreadyInUse'
            description='Label already in use error message'
            defaultMessage='This label is already in use'
        />
    ),
    INVALID_CODE_SCANNED: (
        <FormattedMessage
            id='errors.invalidCodeScanned'
            description='Invalid code scanned error message'
            defaultMessage='Invalid code scanned'
        />
    ),
    UNKNOWN_ENTITY: unknownEntity,
    ENTITIES_NOT_FOUND: entitiesNotFound,
    ENTITY_NOT_FOUND: entityNotFound,
    ENTITY_NO_MATCH: entityNoMatch,
    CODE_ALREADY_ADDED: formattedCodeAlreadyUpdatedMessage,
    UNRECOGNIZED_CODE: (
        <FormattedMessage
            id='errors.unrecognizedCode'
            description='Unrecognized code error message'
            defaultMessage='Unrecognized code'
        />
    ),
    UNRECOGNIZED_CODE_TRY_AGAIN: (
        <FormattedMessage
            id='errors.unrecognizedCodePleaseTryAgain'
            description='Unrecognized code error message'
            defaultMessage='Unrecognized code, please try again.'
        />
    ),
    UNLINKED_IDENTIFICATION: (
        <FormattedMessage
            id='errors.unlinkedIdentification'
            description='Error message when a scanned code is recognized but not linked to anything'
            defaultMessage='This code was recognized but is not linked to anything yet. Please contact support.'
        />
    ),
    UNLINKED_IDENTIFICATION_TRY_AGAIN: (
        <FormattedMessage
            id='errors.unlinkedIdentificationTryAgain'
            description='Error message when a scanned code is recognized but not linked to anything, with retry suggestion'
            defaultMessage='This code was recognized but is not linked to anything yet. Please try a different code or contact support.'
        />
    ),
    NOT_FOUND: (
        <FormattedMessage
            id='errors.notFound'
            description='Not found error message'
            defaultMessage='Not found'
        />
    ),
    TRACKING_NUMBER_EXISTS: (
        <FormattedMessage
            id='errors.trackingNumberExists'
            description='Tracking number exists error message'
            defaultMessage='Tracking number already exists'
        />
    ),
    NO_DATA_AVAILABLE: (
        <FormattedMessage
            id='errors.noDataAvailable'
            description='No data available error message'
            defaultMessage='No data available'
        />
    ),
    NOT_IN_BUDGET: (
        <FormattedMessage
            id='errors.notInBudget'
            description='Not in budget error message'
            defaultMessage='Not in budget'
        />
    ),
    OUT_OF_STOCK: (
        <FormattedMessage
            id='errors.outOfStock'
            description='Out of stock error message'
            defaultMessage='Out of stock'
        />
    ),
    NOT_IN_STOCK: (
        <FormattedMessage
            id='errors.notInStock'
            description='Not in stock error message'
            defaultMessage='Not in stock'
        />
    ),
    TRY_ONE_OF_THE_FOLLOWING_LOCATIONS: (
        <FormattedMessage
            id='errors.tryOneOfTheFollowingLocations'
            description='Try one of the following locations error message'
            defaultMessage='Try one of the following locations:'
        />
    ),
    PRODUCT_AVAILABLE_IN_FOLLOWING_LOCATIONS: (
        <FormattedMessage
            id='errors.productAvailableInFollowingLocations'
            description='Product available in following locations error message'
            defaultMessage='Your product is available in the following locations:'
        />
    ),
    NOT_AUTHORIZED: (
        <FormattedMessage
            id='errors.notAuthorized'
            description='Not authorized error message'
            defaultMessage='Not authorized'
        />
    ),
    NOT_CERTIFIED: (
        <FormattedMessage
            id='errors.notCertified'
            description='Error message shown when a user is not certified to consume an equipment product'
            defaultMessage='You are not certified'
        />
    ),
    NO_BADGE: (
        <FormattedMessage
            id='errors.noBadge'
            description='Message when no badge exists for user'
            defaultMessage='No badge'
        />
    ),
    NO_BASIC_AUTH: (
        <FormattedMessage
            id='errors.noBasicAuth'
            description='Message when user does not have basic auth credentials'
            defaultMessage='No basic auth'
        />
    ),
    FAILED_TO_REMOVE_ENTITY: failedToRemoveEntity,
    BADGE_ALREADY_LINKED: (
        <FormattedMessage
            id='errors.badgeAlreadyLinked'
            description='Badge already linked error message'
            defaultMessage='This badge is already linked to a user.'
        />
    ),
    BUG_REPORT: {
        BUTTON: (
            <FormattedMessage
                id='SentryErrorBoundary.ReportBug'
                description='Button label to open the bug report form'
                defaultMessage='Report a bug'
            />
        ),
        FORM_EMAIL_LABEL: (
            <FormattedMessage
                id='SentryErrorBoundary.Form.Email'
                description='Email field label in the bug report form'
                defaultMessage='Email'
            />
        ),
        FORM_MESSAGE_LABEL: (
            <FormattedMessage
                id='SentryErrorBoundary.Form.Message'
                description='Message field label in the bug report form'
                defaultMessage='What happened?'
            />
        ),
        FORM_SUBMIT: (
            <FormattedMessage
                id='SentryErrorBoundary.Form.Submit'
                description='Submit button label in the bug report form'
                defaultMessage='Submit report'
            />
        ),
        FORM_SENDING: (
            <FormattedMessage
                id='SentryErrorBoundary.Form.Sending'
                description='Sending state label in the bug report form'
                defaultMessage='Sending...'
            />
        ),
        FORM_SUCCESS: bugReportFormSuccess,
        FORM_ERROR: (
            <FormattedMessage
                id='SentryErrorBoundary.Form.SubmitError'
                description='Error message shown when the bug report submission fails'
                defaultMessage='Something went wrong submitting your report. Please try again.'
            />
        )
    }
};
function formattedCodeAlreadyUpdatedMessage(text: React.ReactNode): React.ReactNode {
    return (
        <FormattedMessage
            id='errors.codeAlreadyAdded'
            description='Code already added error message'
            defaultMessage='{text} was already added to the list'
            values={{
                text: text
            }}
        />
    );
}
function unknownEntity(text: React.ReactNode): React.ReactNode {
    return (
        <FormattedMessage
            id='errors.unknownEntity'
            description='Unknown entity error message'
            defaultMessage='Unknown {text}'
            values={{ text: text }}
        />
    );
}
function entitiesNotFound(text: React.ReactNode): React.ReactNode {
    return (
        <FormattedMessage
            id='errors.entitiesNotFound'
            description='Entities not found error message'
            defaultMessage='No {text} found'
            values={{ text: text }}
        />
    );
}
function entityNotFound(text: React.ReactNode): React.ReactNode {
    return (
        <FormattedMessage
            id='errors.entityNotFound'
            description='Entity not found error message'
            defaultMessage='{text} not found'
            values={{ text: text }}
        />
    );
}
function entityNoMatch(text: React.ReactNode, searchQuery: string): React.ReactNode {
    return (
        <FormattedMessage
            id='errors.entityNoMatch'
            description='Entity no match error message'
            defaultMessage='No {text} found matching "{searchQuery}"'
            values={{ text: text, searchQuery: searchQuery }}
        />
    );
}

function failedToRemoveEntity(text: React.ReactNode): React.ReactNode {
    return (
        <FormattedMessage
            id='errors.failedToRemoveEntity'
            description='Failed to remove entity error message'
            defaultMessage='Failed to remove {text}'
            values={{ text: text }}
        />
    );
}

function bugReportFormSuccess(strong: (chunks: React.ReactNode) => React.ReactNode): React.ReactNode {
    return (
        <FormattedMessage
            id='SentryErrorBoundary.Form.SubmitSuccess'
            description='Success message shown after a bug report is submitted'
            defaultMessage='<strong>Thank you!</strong> Your report has been sent. We will look into it as soon as possible.'
            values={{ strong }}
        />
    );
}
